import Ajax from '@utils/ajax';

import {
	AxiosPromise,
} from 'axios';

export function finishDeductionSyncWizard(traxCldIds: number[]): AxiosPromise {
	return Ajax.post(`/payroll/deduction_sync/ajax/create_quick_build_benefit_plan_deductions`, traxCldIds);
}
